export default Object.freeze({
  InProcess: 2,
  Closed: 3,
  Submitted: 4,
});
